import { Card, Collapse, Flex, theme } from 'antd'
import { FC, useMemo, useState } from 'react'
import { useGetMachinesQuery } from '../../../../store/api/machines-api'
import { formatMileageMeters, toMeters } from '../../helpers/consumption-helpers'
import { groupMachinesByBrand, PRINTING_MACHINE_TYPE_NAMES } from './helpers/group-machines-by-brand'

const MachineCountersBar: FC = () => {
    const { token } = theme.useToken()
    const [activeKeys, setActiveKeys] = useState<string[]>(['mileage'])
    const { data, isLoading } = useGetMachinesQuery({
        filters: {
            machine_type: {
                name: {
                    $in: [...PRINTING_MACHINE_TYPE_NAMES],
                },
            },
        },
        populate: {
            machine_brand: true,
            machine_type: true,
        },
        sort: ['name:asc'],
        pagination: { pageSize: 200, page: 1 },
    })

    const brandGroups = useMemo(() => groupMachinesByBrand(data?.data || []), [data?.data])

    if (isLoading || !brandGroups.length) return null

    return (
        <Collapse
            activeKey={activeKeys}
            onChange={keys => setActiveKeys(keys as string[])}
            style={{ marginBottom: 16 }}
            items={[
                {
                    key: 'mileage',
                    label: 'Пробег станков',
                    children: (
                        <Flex wrap gap={12}>
                            {brandGroups.map(group => (
                                <Card
                                    key={group.brand}
                                    size="small"
                                    title={group.brand}
                                    style={{
                                        minWidth: 220,
                                        flex: '1 1 220px',
                                        maxWidth: 360,
                                        background: token.colorBgContainer,
                                    }}
                                    styles={{
                                        header: {
                                            minHeight: 36,
                                            background: token.colorFillAlter,
                                        },
                                        body: { padding: '8px 12px 12px' },
                                    }}
                                >
                                    <Flex vertical gap={0}>
                                        {group.machines.map((machine, index) => {
                                            const counterMeters = toMeters(machine.machineCounter)
                                            const isLast = index === group.machines.length - 1

                                            return (
                                                <Flex
                                                    key={machine.documentId}
                                                    justify="space-between"
                                                    align="center"
                                                    gap={12}
                                                    style={{
                                                        padding: '6px 0',
                                                        borderBottom: isLast
                                                            ? undefined
                                                            : `1px solid ${token.colorBorderSecondary}`,
                                                    }}
                                                >
                                                    <span>{machine.name}</span>
                                                    <strong
                                                        style={{
                                                            fontVariantNumeric: 'tabular-nums',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {counterMeters
                                                            ? `${formatMileageMeters(counterMeters)} м`
                                                            : '—'}
                                                    </strong>
                                                </Flex>
                                            )
                                        })}
                                    </Flex>
                                </Card>
                            ))}
                        </Flex>
                    ),
                },
            ]}
        />
    )
}

export default MachineCountersBar
